module.exports = __webpack_public_path__ + "static/img/SPIRAL.b92553f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SPIRAL.png
// module id = r/Ly
// module chunks = 1